// The element pages scroll in: the <main> of the $locale layout
export const PAGE_SCROLL_CONTAINER_ID = "page-scroll-container";
